export default `
  mutation getUserToken($token: String!, $login_type: String!) {
    getSocialLoginToken(token: $token, login_type: $login_type)
  }
`;
